import { ConditionChild, DesignData } from '../types';
import { resolveSharedTextField } from '../util/sharedTextFields';
import { isSlotFrameActive } from '../util/slotLayout/slotFrameVisibility';

function getVisiblePersonalizationFields(
  design: DesignData | undefined,
  elements: ConditionChild[],
  spreadIndex: number,
) {
  const spread = design?.spreads[spreadIndex];
  const media = new Map(
    spread?.pages.flatMap((page) => page.groups.media || []).map((element) => [element.uuid, element]),
  );
  return elements.filter((child) => {
    if (child.type === 'condition') {
      return !!spread?.conditionGroup?.conditions[child.id];
    }
    const element = media.get(child.id);
    if (!element || element.personalizationLocked) {
      return false;
    }
    // A product's picklist lists the layers of every frame the product can take; the buyer
    // fills in the one on the page for the picked count.
    if (element.slotFrame && spread && !isSlotFrameActive(spread, element.slotFrame)) {
      return false;
    }
    return element.type !== 'text' || resolveSharedTextField(design, element, spreadIndex).isLead;
  });
}

export default getVisiblePersonalizationFields;
